module.exports = __webpack_public_path__ + "img/FB_Info_Game_Page_6-2.124f2a5a.png";